import bubblechatLocaleEn from './locales/bubblechat/locale-en.json';
import bubblechatLocaleKo from './locales/bubblechat/locale-ko.json';
import tingleLocaleEn from './locales/tingle/locale-en.json';
import tingleLocaleKo from './locales/tingle/locale-ko.json';

export const languages = ['en', 'ko'] as const;

export type Languages = (typeof languages)[number];

export const SERVICE_RESOURCES = {
  bubblechat: {
    en: { translation: bubblechatLocaleEn },
    ko: { translation: bubblechatLocaleKo },
  },
  tingle: {
    en: { translation: tingleLocaleEn },
    ko: { translation: tingleLocaleKo },
  },
};

const services = ['bubblechat', 'tingle'] as const;
type ServiceName = (typeof services)[number];

export const serviceName: ServiceName = (import.meta.env.VITE_APP_SERVICE_NAME as ServiceName) || 'bubblechat';

export const resources = SERVICE_RESOURCES[serviceName] || SERVICE_RESOURCES.bubblechat;
